import { Injectable } from '@angular/core';
import { GlobalService } from '@common/global';
import { HttpParams } from '@angular/common/http';
import { ApiService } from '@services/api.service';
@Injectable({
  providedIn: 'root'
})
export class CommonService {

 
  constructor(private _global: GlobalService, private api: ApiService) { }
  common(obj,operation,application) {
    
    let operations=this._global.api_doc(application,'operations');
   let url= this._global.getVal(operations,operation+'.url','');
    let params = new HttpParams();
    Object.entries(obj).forEach(([key, value]) => {
      let v = obj[key];
      if (key == 'component') {
        params = params.append(key, this._global.getComponent(v));
      } else {
        params = params.append(key, v);
      }
    });
    params = params.append('siteId', this._global.SITEID);
    params = params.append('orgId', this._global.ORGID);
    params = params.append('domainName', this._global.DOMAIN_NAME);
    params = params.append('sess_cookie', this._global.getToken());
    params = params.append('token', this._global.getToken());
    return this.api.call(url, params);
  }
}
